// Selectors ==========================================================================================================================================================================
let modalIdDelete = document.getElementById("modalIdDelete");
let myTgrBtnDelete = document.querySelector(".my-tgr-btn-delete");
let myInputDelete = document.querySelector(".my-input-delete");
let myInputDateDelete = document.querySelector(".my-input-date-delete");
let myInputWeightDelete = document.querySelector(".my-input-weight-delete");
let myModalContentDelete = document.querySelector(".my-modal-content-delete");
let myModalBtnDelete = document.querySelector(".my-modal-btn-delete");
let myModalContentLoaderDelete = document.querySelector(".my-modal-content-loader-delete");
let myModalContentConfirmationDelete = document.querySelector(".my-modal-content-confirmation-delete");
let myModalContentErrorDelete = document.querySelector(".my-modal-content-error-delete");

// Edit Patient =======================================================================================================================================================================

// Modal trigger btn -----------------------------------------------------------------------
let modalDelete;         // To create modal instance (and be able to show()).
myTgrBtnDelete.addEventListener('click', (e) => {
    // Prevent submit of form
    e.preventDefault();
    // Read input value
    let inputValue = myInputDelete.value;
    let inputDateValue = myInputDateDelete.value;
    let inputWeightValue = myInputWeightDelete.value;
    // Reset modal content delete and validate null value
    if (!inputValue || !inputDateValue || !inputWeightValue) {
        myModalContentDelete.querySelector("i").classList.add("fa-exclamation");
        myModalContentDelete.querySelector("p").innerHTML = `Id can not be empty`;
        myModalBtnDelete.classList.add("d-none");
    } else {
        myModalContentDelete.querySelector("i").classList.remove("fa-exclamation");
        myModalContentDelete.querySelector("p").innerHTML = `Are you sure you want to <span class="text-warning fw-bold">EDIT</span> weight for patient <strong>${inputValue}</strong>?`;
        myModalBtnDelete.classList.remove("d-none");
    }
    // Create instance of modal
    modalDelete = bootstrap.Modal.getOrCreateInstance(modalIdDelete);
    modalDelete.show();
})

// Modal btn  -----------------------------------------------------------------------------
let deleted = false;  // To track delete operation.
myModalBtnDelete.addEventListener('click', () => {
    // Get the id to be updated
    let id = myInputDelete.value;
    let idDate = myInputDateDelete.value;
    let idWeight = myInputWeightDelete.value;
    // Activate loader
    myModalContentDelete.classList.add('d-none');
    myModalContentLoaderDelete.classList.remove('d-none');
    // Call editPatientAPI function
    editPatientAPI(id, idDate, idWeight);
});

// Delete API -----------------------------------------------------------------------------
let error = false; // To track error.
async function editPatientAPI(id, idDate, idWeight) {
    let response = await fetch(`${process.env.SELFHELP_API}/patients/${id}/set-starting-weight?user=${localStorage.getItem("username")}`, {
        method: "PUT",
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
            'Content-Type': 'application/json'                // THIS LINE IS SUPER IMPORTANT.
        },
        body: JSON.stringify(
            {
                startingWeight: idWeight,
                date: idDate
            }
        )
    })

    if (response.status != 400 && response.status != 403 && response.status != 404 && response.status != 500 && response.status != 502) {
        let responseParsed = await response.json();

        console.log("API response - Success:");
        console.log(responseParsed);

        // Hide loader
        myModalContentLoaderDelete.classList.add('d-none');
        // Show confirmation
        myModalContentConfirmationDelete.querySelector("p").innerHTML = `Weight for patient <strong>${id}</strong> has been modified!`
        myModalContentConfirmationDelete.classList.remove('d-none');

        deleted = true;

    } else {
        let responseParsed = await response.json();

        console.log("API response - Error:");
        console.log(responseParsed);
        
        // Hide loader
        myModalContentLoaderDelete.classList.add('d-none');
        // Show error
        myModalContentErrorDelete.querySelector("p").innerHTML = responseParsed.message;
        myModalContentErrorDelete.classList.remove('d-none');

        error = true;
    }
}

// Reset modal after deleting -----------------------------------------------------------
modalIdDelete.addEventListener('hidden.bs.modal', event => {
    if (deleted) {
        myModalContentConfirmationDelete.classList.add('d-none');
        myModalContentDelete.classList.remove('d-none');
        myInputDelete.value = "";
        myInputDateDelete.value = "";
        myInputWeightDelete.value = "";

        deleted = false;        // Reset operation.
    }

    if (error) {
        myModalContentErrorDelete.classList.add('d-none');
        myModalContentDelete.classList.remove('d-none');

        error = false;          // Reset error.
    }
})